import {twJoin} from 'tailwind-merge'

import {IconPlaceholderAvatar} from '@sdox/icons/large'
import {LazyImage} from '@sdox/ui'

interface VideoOverlayAvatarProps {
  playing?: boolean
  thumbnail?: string | null
}

export const MediaOverlayAvatar = (props: VideoOverlayAvatarProps) => {
  const {playing, thumbnail} = props

  const className = twJoin(
    'absolute z-20 mb-spacing-12 size-spacing-96 rounded-full',
    'transition-opacity duration-500',
    !thumbnail && 'flex shrink-0 justify-center items-center bg-media-bg',
    playing ? 'opacity-0' : 'opacity-100',
  )

  if (!thumbnail) {
    return (
      <div className={className}>
        <IconPlaceholderAvatar className={'size-spacing-96'}/>
      </div>
    )
  }

  return (
    <LazyImage
      src={thumbnail}
      className={className}
    />
  )
}
